namespace Matrix.Exceptions {
    export interface ExceptionInboxForm {
        Description: Serenity.StringEditor;
        ExceptionTypeCode: Serenity.StringEditor;
        ExceptionSource: Serenity.StringEditor;
        ExceptionContext: Serenity.StringEditor;
        ExceptionKey: Serenity.StringEditor;
        ExceptionSchema: Serenity.StringEditor;
        ExceptionTable: Serenity.StringEditor;
        SeverityCode: Serenity.StringEditor;
        SeverityScore: Serenity.DecimalEditor;
        SystemTags: ExceptionTagEditor;
        UserTags: ExceptionTagEditor;
        AssignedTo: Serenity.LookupEditor;
        AssignedBy: StaticTextBlock;
        AssignedWhen: ReadOnlyDateTime;
        IgnorePolicyCode: FormatLookupEditor;
        IgnoredBy: StaticTextBlock;
        IgnoredWhen: ReadOnlyDateTime;
        IgnoredUntil: ReadOnlyDateTime;
        ReviewedBy: StaticTextBlock;
        ReviewedWhen: ReadOnlyDateTime;
        CompletedBy: StaticTextBlock;
        CompletedWhen: ReadOnlyDateTime;
        Properties: Serenity.TextAreaEditor;
        Notes: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ExceptionInboxForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Exceptions.Forms.ExceptionInboxForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExceptionInboxForm.init)  {
                ExceptionInboxForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = ExceptionTagEditor;
                var w3 = s.LookupEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;
                var w6 = FormatLookupEditor;
                var w7 = s.TextAreaEditor;

                Q.initFormType(ExceptionInboxForm, [
                    'Description', w0,
                    'ExceptionTypeCode', w0,
                    'ExceptionSource', w0,
                    'ExceptionContext', w0,
                    'ExceptionKey', w0,
                    'ExceptionSchema', w0,
                    'ExceptionTable', w0,
                    'SeverityCode', w0,
                    'SeverityScore', w1,
                    'SystemTags', w2,
                    'UserTags', w2,
                    'AssignedTo', w3,
                    'AssignedBy', w4,
                    'AssignedWhen', w5,
                    'IgnorePolicyCode', w6,
                    'IgnoredBy', w4,
                    'IgnoredWhen', w5,
                    'IgnoredUntil', w5,
                    'ReviewedBy', w4,
                    'ReviewedWhen', w5,
                    'CompletedBy', w4,
                    'CompletedWhen', w5,
                    'Properties', w7,
                    'Notes', w7,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
